/* eslint-disable no-use-before-define */

import months from '../months.json';

export function usePreviewtoString(detail, lang, logo, width) {
    const vendorPrivacyPolicy = detail?.vendorPrivacyPolicy;
    const vendorIntroductionLawfulBasis = detail?.vendorIntroductionLawfulBasis;
    const vendorPersonalDataCollect = detail?.vendorPersonalDataCollect;
    const vendorReasonCollectedData = detail?.vendorReasonCollectedData;
    const vendorTransferPersonalData = detail?.vendorTransferPersonalData;
    const vendorRetainPersonalData = detail?.vendorRetainPersonalData;
    const vendorDataSubjectRight = detail?.vendorDataSubjectRight;
    const vendorPolicyChange = detail?.vendorPolicyChange;

    const getFileDate = (vendorDate) => {
        if (vendorDate) {
            const split = vendorDate.split('/');
            const year = split[2].split(' ');
            const date_ = `_${split[0]}-${split[1]}-${year[0]}_`;
            console.log(date_);
            return date_;
        }
        return '';
    };

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    const body = `
    <body style="word-break: break-word;">
        <center>
        ${
            logo &&
            `<img
            width="${width}" height="100"
        style="object-fit: cover;"
        src=${logo}
        alt="logo "/>`
        }</center>
        <center>
            <h3>
                ${
                    lang === 'TH'
                        ? vendorPrivacyPolicy?.vendorPrivacyPolicyNameTh
                        : vendorPrivacyPolicy?.vendorPrivacyPolicyNameEn
                }
            </h3>
        </center>
            <p className="text-left">
                ${
                    vendorIntroductionLawfulBasis?.vendorIntroductionIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? vendorIntroductionLawfulBasis?.vendorIntroductionContentTh ||
                              '-'
                            : vendorIntroductionLawfulBasis?.vendorIntroductionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorIntroductionLawfulBasis?.vendorLawfulBasisIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? vendorIntroductionLawfulBasis?.vendorLawfulBasisTitleTh
                            : vendorIntroductionLawfulBasis?.vendorLawfulBasisTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    vendorIntroductionLawfulBasis?.vendorLawfulBasisIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? vendorIntroductionLawfulBasis?.vendorLawfulBasisContentTh ||
                              '-'
                            : vendorIntroductionLawfulBasis?.vendorLawfulBasisContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorPersonalDataCollect?.vendorPersonalDataIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? vendorPersonalDataCollect?.vendorPersonalDataTitleTh
                            : vendorPersonalDataCollect?.vendorPersonalDataTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
            ${
                vendorPersonalDataCollect?.vendorPersonalDataIsDisplay === true
                    ? lang === 'TH'
                        ? vendorPersonalDataCollect?.vendorPersonalDataContentTh ||
                          '-'
                        : vendorPersonalDataCollect?.vendorPersonalDataContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                vendorPersonalDataCollect?.vendorSourceIsDisplay === true
                    ? lang === 'TH'
                        ? vendorPersonalDataCollect?.vendorSourceTitleTh
                        : vendorPersonalDataCollect?.vendorSourceTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                vendorPersonalDataCollect?.vendorSourceIsDisplay === true
                    ? lang === 'TH'
                        ? vendorPersonalDataCollect?.vendorSourceContentTh ||
                          '-'
                        : vendorPersonalDataCollect?.vendorSourceContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                vendorReasonCollectedData?.vendorPurposeIsDisplay === true
                    ? lang === 'TH'
                        ? vendorReasonCollectedData?.vendorPurposeTitleTh
                        : vendorReasonCollectedData?.vendorPurposeTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                vendorReasonCollectedData?.vendorPurposeIsDisplay === true
                    ? lang === 'TH'
                        ? vendorReasonCollectedData?.vendorPurposeContentTh ||
                          '-'
                        : vendorReasonCollectedData?.vendorPurposeContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                vendorTransferPersonalData?.vendorDisclosureIsDisplay === true
                    ? lang === 'TH'
                        ? vendorTransferPersonalData?.vendorDisclosureTitleTh
                        : vendorTransferPersonalData?.vendorDisclosureTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                vendorTransferPersonalData?.vendorDisclosureIsDisplay === true
                    ? lang === 'TH'
                        ? vendorTransferPersonalData?.vendorDisclosureContentTh ||
                          '-'
                        : vendorTransferPersonalData?.vendorDisclosureContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                vendorTransferPersonalData?.vendorInternationalIsDisplay ===
                true
                    ? lang === 'TH'
                        ? vendorTransferPersonalData?.vendorInternationalTitleTh ||
                          '-'
                        : vendorTransferPersonalData?.vendorInternationalTitleEn ||
                          '-'
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
                ${
                    vendorTransferPersonalData?.vendorInternationalIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? vendorTransferPersonalData?.vendorInternationalContentTh ||
                              '-'
                            : vendorTransferPersonalData?.vendorInternationalContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorRetainPersonalData?.vendorRetentionIsDisplay === true
                        ? lang === 'TH'
                            ? vendorRetainPersonalData?.vendorRetentionTitleTh
                            : vendorRetainPersonalData?.vendorRetentionTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    vendorRetainPersonalData?.vendorRetentionIsDisplay === true
                        ? lang === 'TH'
                            ? vendorRetainPersonalData?.vendorRetentionContentTh ||
                              '-'
                            : vendorRetainPersonalData?.vendorRetentionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorRetainPersonalData?.vendorSecurityIsDisplay === true
                        ? lang === 'TH'
                            ? vendorRetainPersonalData?.vendorSecurityTitleTh
                            : vendorRetainPersonalData?.vendorSecurityTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    vendorRetainPersonalData?.vendorSecurityIsDisplay === true
                        ? lang === 'TH'
                            ? vendorRetainPersonalData?.vendorSecurityContentTh ||
                              '-'
                            : vendorRetainPersonalData?.vendorSecurityContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorDataSubjectRight?.vendorDataSubjectRightIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? vendorDataSubjectRight?.vendorDataSubjectRightTitleTh
                            : vendorDataSubjectRight?.vendorDataSubjectRightTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    vendorDataSubjectRight?.vendorDataSubjectRightIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? vendorDataSubjectRight?.vendorDataSubjectRightContentTh ||
                              '-'
                            : vendorDataSubjectRight?.vendorDataSubjectRightContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorPolicyChange?.vendorChangeIsDisplay === true
                        ? lang === 'TH'
                            ? vendorPolicyChange?.vendorChangeTitleTh
                            : vendorPolicyChange?.vendorChangeTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    vendorPolicyChange?.vendorChangeIsDisplay === true
                        ? lang === 'TH'
                            ? vendorPolicyChange?.vendorChangeContentTh || '-'
                            : vendorPolicyChange?.vendorChangeContentEn || '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorPolicyChange?.vendorDataControllerIsDisplay === true
                        ? lang === 'TH'
                            ? vendorPolicyChange?.vendorDataControllerTitleTh
                            : vendorPolicyChange?.vendorDataControllerTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    vendorPolicyChange?.vendorDataControllerIsDisplay === true
                        ? lang === 'TH'
                            ? vendorPolicyChange?.vendorDataControllerContentTh ||
                              '-'
                            : vendorPolicyChange?.vendorDataControllerContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    vendorPolicyChange?.vendorDataProtectionIsDisplay === true
                        ? lang === 'TH'
                            ? vendorPolicyChange?.vendorDataProtectionTitleTh
                            : vendorPolicyChange?.vendorDataProtectionTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    vendorPolicyChange?.vendorDataProtectionIsDisplay === true
                        ? lang === 'TH'
                            ? vendorPolicyChange?.vendorDataProtectionContentTh ||
                              '-'
                            : vendorPolicyChange?.vendorDataProtectionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>${lang === 'TH' ? 'ฉบับ ณ วันที่' : 'Edition as of'}&nbsp;&nbsp;
                ${getCurrentDate(vendorPrivacyPolicy?.effectiveDate)}</h4>
        <script type="text/javascript">
                $(document).ready(function() {
                let allElements = $('*');
                let converted = htmlDocx.asBlob(allElements.html());
                saveAs(converted, '${
                    lang === 'TH'
                        ? vendorPrivacyPolicy?.vendorPrivacyPolicyNameTh +
                          `${getFileDate(
                              vendorPrivacyPolicy?.updateDate
                          )}TH.docx`
                        : vendorPrivacyPolicy?.vendorPrivacyPolicyNameEn +
                          `${getFileDate(
                              vendorPrivacyPolicy?.updateDate
                          )}EN.docx`
                }');
                setTimeout(()=> window.close(), 100)
                });
        </script>
            </body>
    `;

    return {
        html: `
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
        </head>
            ${body}
        </html>`,
        body,
    };
}
